import { render, staticRenderFns } from "./LinkUserModal.vue?vue&type=template&id=01de936f&scoped=true"
import script from "./LinkUserModal.vue?vue&type=script&lang=js"
export * from "./LinkUserModal.vue?vue&type=script&lang=js"
import style0 from "./LinkUserModal.vue?vue&type=style&index=0&id=01de936f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de936f",
  null
  
)

export default component.exports